import React, { useState } from 'react'
import Container from '@material-ui/core/Container'
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
import { FormattedMessage } from 'react-intl'
import Section from '../../components/Section'
import ProductsImage from '../../components/Benefit/ProductsImage'
import EarningsCalculator from './EarningsCalculator'

const styles = ({ palette }) => {
  const subHeader = {
    color: palette.text.primary,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.5',
    letterSpacing: '0.51px',
    whiteSpace: 'pre-line',
    paddingLeft: '20px',
    marginTop: '14px',
  }
  const subHeaderChile = { ...subHeader }
  delete subHeaderChile.maxWidth
  return {
    subHeader,
    subHeaderChile,
    productImage: {
      display: 'flex',
      alignSelf: 'center',
      objectFit: 'scale-down',
      width: '240px'
    }
  }
}

const EarningsSection = ({
  classes,
  chartLevelsData,
  chartInfoData,
  onlineChartInfoData,
  productsData,
  catalogData,
  productsImage,
  langKey,
  isEloThemeActive,
  ...props
}) => {
  const [tabActive, setTabActive] = useState(0)
  const styleStrategy = {
    es_CO: classes.subHeaderChile,
    es_CL: classes.subHeaderChile,
    __default__: classes.subHeader
  }
  return (
    <Section
      headingTitle={<FormattedMessage id="earningsHeadingTitle" />}
      headingSubtitle={<FormattedMessage id="earningsHeadingSubtitle" />}
      isEloThemeActive={isEloThemeActive}
      subHeaderStyle={
        styleStrategy[langKey]
          ? styleStrategy[langKey]
          : styleStrategy.__default__
      }
      {...props}
    >
      <Container component="article">
        <Grid direction="column" alignItems="center" container>
          <EarningsCalculator
            tabActive={tabActive}
            setTabActive={setTabActive}
            isEloThemeActive={isEloThemeActive}
            key={productsImage}
            langKey={langKey}
            products={productsData.edges}
            catalog={catalogData?.edges}
            chartLevels={chartLevelsData.edges}
            chartInfo={chartInfoData.edges}
            onlineChartInfo={onlineChartInfoData?.edges}
            productsImage={
              <ProductsImage
                classes={classes.productImage}
                lang={langKey}
                tabActive={tabActive}
                isEloThemeActive={isEloThemeActive}
              />
            }
          />
        </Grid>
      </Container>
    </Section>
  )
}

export default withStyles(styles)(EarningsSection)
